export default __webpack_public_path__ + "static/media/video-play.2e286cc7.svg";